import { isValue } from "#webapp/src/util/errorable.util";
import { EFlex, getFlexFromEvent } from "#webapp/src/util/event-tag.util";
import { Person } from "@clockwise/schema";
import React from "react";
import AttendeeSlotPains from "./AttendeeSlotPains";
import {
  EventSchedulingQueryEvent,
  EventSchedulingQueryOrg,
  baseClasses,
  getOrderedAttendeesAndPersonsMaps,
} from "./EventScheduling";

const AttendeesSlotPains = ({
  org,
  event,
  onInvite,
}: {
  org: EventSchedulingQueryOrg | undefined | null;
  event: EventSchedulingQueryEvent | undefined;
  onInvite?: (person: Person | null) => void | undefined;
}) => {
  if (!org || !event || !isValue(org?.computeCurrentSlotImpactErrorable)) {
    return null;
  }

  const { personImpacts, personMap, attendeeMap } = getOrderedAttendeesAndPersonsMaps({
    org,
    event,
  });

  return (
    <div className={baseClasses + " cw-flex-col"}>
      {personImpacts.slice(0, 15).map((personImpact, index) => {
        const person = personMap[personImpact.calendarId] || null;
        const attendee = attendeeMap[personImpact.calendarId] || null;

        let flexStatus = EFlex.Pin;
        if (event?.__typename == "Event") {
          flexStatus = getFlexFromEvent(event, true);
        }

        return (
          <AttendeeSlotPains
            org={org}
            key={personImpact.calendarId || index}
            personImpact={personImpact}
            person={person}
            attendee={attendee}
            hidePainsForAttendeeWhoHaveDeclined
            onInvite={onInvite}
            eventFlexStatus={flexStatus}
          />
        );
      })}
      {personImpacts.length > 15 ? (
        <div
          className="cw-flex cw-overflow-hidden cw-flex-shrink-0 cw-rounded-full cw-items-center cw-justify-center cw-text-white cw-bg-gray-400 cw-h-[34px] cw-w-[34px] cw-font-semibold"
          data-tip
        >
          +{personImpacts.length - 15}
        </div>
      ) : null}
    </div>
  );
};

export default AttendeesSlotPains;
